// Single source of truth for the backend API base URL.
// Works in both local dev (via CRA proxy) and production (same-origin /api).
export const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";

// --- Session helpers ---

// Reads the saved session (token + Client_ID/Company_ID/User_ID/Role) after login.
// Returns null if nobody is logged in.
export const getSession = () => {
  try {
    const raw = localStorage.getItem("courier_session");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

// Clears the session (use this for Logout).
export const clearSession = () => {
  localStorage.removeItem("courier_session");
};

// Builds fetch() headers with the auth token attached, for any request
// that needs to identify who's calling (which will be most of them going forward).
// Usage: fetch(url, { headers: authHeaders() })
// Usage with JSON body: fetch(url, { method: "POST", headers: authHeaders(), body: JSON.stringify(data) })
export const authHeaders = () => {
  const session = getSession();
  return {
    "Content-Type": "application/json",
    ...(session?.token ? { Authorization: `Bearer ${session.token}` } : {}),
  };
};

export default API_BASE_URL;